import {charcoal} from '../../sass/v2/_exports.sass';

export const EditLineIcon = ({color = charcoal, className = '', ratio = 1}) => {
  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.3933 9.86799C25.8973 9.36399 26.1747 8.69466 26.1747 7.98266C26.1747 7.27066 25.8973 6.60132 25.3933 6.09732L23.2787 3.98266C22.7747 3.47866 22.1053 3.20132 21.3933 3.20132C20.6813 3.20132 20.012 3.47866 19.5093 3.98132L5.33334 18.1133V24H11.2173L25.3933 9.86799ZM21.3933 5.86799L23.5093 7.98132L21.3893 10.0933L19.2747 7.97999L21.3933 5.86799ZM8 21.3333V19.22L17.3867 9.86266L19.5013 11.9773L10.116 21.3333H8ZM5.33334 26.6667H26.6667V29.3333H5.33334V26.6667Z"
        fill={color}
      />
    </svg>
  );
};
